/* eslint-disable prefer-template */
/* eslint-disable no-unneeded-ternary */
import CardWithTitle from 'components/CardWithTitle';
import DateFormatter from 'components/DateFormatter';
import React from 'react';
import { Col, Label, Row } from 'reactstrap';
import { currencyToLocal, NumberWithCommasFormat } from 'utils/constants';

const OrderCardDetails = ({ currentRow }) => {
  const {
    id,
    quantity,
    grade,
    rate,
    rateUnit,
    buyerGstBillingAddress,
    billingAddress,
    deliveryAddress,
    createdAt,
    availInsurance,
    sellerCommissionAmount,
  } = currentRow;

  const formatAddress = (address) => {
    if (!address) return '';
    if (typeof address === 'string') {
      return address.trim();
    }

    const rawText =
      address?.displayAddress ||
      address?.addressText ||
      address?.orderDeliveryAddress ||
      address?.buyerGstBillingAddress ||
      address?.pickupAddressText;

    if (rawText) {
      return String(rawText).trim();
    }

    const getText = (field) => {
      if (!field) return '';
      if (typeof field === 'string') return field.trim();
      if (typeof field !== 'object') return '';
      return (
        field?.cityName ||
        field?.stateName ||
        field?.country ||
        field?.countryName ||
        field?.name ||
        ''
      );
    };

    const parts = [
      address.houseNumber,
      address.street,
      address.area,
      getText(address.city),
      getText(address.state),
      getText(address.country),
      address.pinCode,
    ].filter((part) => part && String(part).trim() !== '');

    return parts.join(', ');
  };

  const billingAddressText =
    formatAddress(billingAddress) || buyerGstBillingAddress || '';

  return (
    <CardWithTitle title="Order">
      {/* <Button
        color="link"
        className="text-decoration-none card-right-btn text-active font-manrope fw-bold f-12 p-0"
      >
        View Offer <HiArrowNarrowRight className="ms-1" size={18} />
      </Button> */}
      <Row>
        <Col sm={4} className="mb-2">
          <Label className="text-gray f-12 text-uppercase fw-medium">
            ORDER NUMBER
          </Label>
          <span className="font-manrope f-12 fw-medium d-block">{id}</span>
        </Col>
        <Col sm={4} className="mb-2">
          <Label className="text-gray f-12 text-uppercase fw-medium">
            GRADE NAME
          </Label>
          <span className="font-manrope f-12 fw-medium d-block">
            {grade?.name}
          </span>
        </Col>
        <Col sm={4} className="mb-2">
          <Label className="text-gray f-12 text-uppercase fw-medium">
            booking Date{' '}
          </Label>
          <span className="font-manrope f-12 fw-medium d-block">
            {createdAt && (
              <DateFormatter
                className="date-inline mt-1"
                dateTime={createdAt}
              />
            )}
          </span>
        </Col>
        <Col sm={4} className="mb-2">
          <Label className="text-gray f-12 text-uppercase fw-medium">
            RATE
          </Label>
          <span className="font-manrope f-12 fw-medium d-block">
            {`${currencyToLocal(rate, rateUnit?.isoCurrencyCode)}/KG`}
          </span>
        </Col>
        <Col sm={4} className="mb-2">
          <Label className="text-gray f-12 text-uppercase fw-medium">
            ORDERED QUANTITY
          </Label>
          <span className="font-manrope f-12 fw-medium d-block">
            {NumberWithCommasFormat(quantity)} MT
          </span>
        </Col>
        <Col sm={4} className="mb-2">
          <Label className="text-gray f-12 text-uppercase fw-medium">
            Insurance{' '}
          </Label>
          <span className="font-manrope f-12 fw-medium d-block">
            {availInsurance ? 'Yes' : 'No'}
          </span>
        </Col>
        <Col sm={4} className="mb-2">
          <Label className="text-gray f-12 text-uppercase fw-medium">
            Seller Commission
          </Label>
          <span className="font-manrope f-12 fw-medium d-block">
            {sellerCommissionAmount
              ? currencyToLocal(
                  sellerCommissionAmount,
                  rateUnit?.isoCurrencyCode,
                )
              : 'N/A'}
          </span>
        </Col>
        <Col sm={12} className="mb-2">
          <Label className="text-gray f-12 text-uppercase fw-medium">
            billing Address{' '}
          </Label>
          {billingAddressText ? (
            <span className="font-manrope f-12 fw-medium d-block">
              {billingAddressText}
            </span>
          ) : (
            <span className="font-manrope f-12 fw-medium d-block">
              Not Available
            </span>
          )}
        </Col>
        <Col sm={12} className="mb-2">
          <Label className="text-gray f-12 text-uppercase fw-medium">
            delivery Address{' '}
          </Label>
          {deliveryAddress ? (
            <span className="font-manrope f-12 fw-medium d-block">
              {formatAddress(deliveryAddress)}
            </span>
          ) : (
            <span className="font-manrope f-12 fw-medium d-block">
              Not Available
            </span>
          )}
        </Col>
      </Row>
    </CardWithTitle>
  );
};

export default OrderCardDetails;
